import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';

const ClozeOptions = ({
	rightSectionProps: { questionId, wordbank },
	isFeedback,
	dataContainer,
}) => {
	const [wordCollection, setWordCollection] = useState(null);
	useEffect(() => {
		if (!isFeedback) {
			appendScript('wordCloudNew');
		}
		return () => {
			removeScript('wordCloudNew');
		};
	}, [isFeedback, wordbank]);

	useEffect(() => {
		if (!!wordbank) {
			let splittedWords = wordbank.split('|');
			setWordCollection(
				Object.keys(splittedWords).map(function (bankKey) {
					return (
						<li data-container={dataContainer} key={`${bankKey}_${questionId}`}>
							{splittedWords[bankKey]}
						</li>
					);
				}),
			);
		}
	}, [dataContainer, questionId, wordbank]);

	return (
		<div className="converse-options collapse show">
			<div className="quiz-area-options">
			    <h6>Choose from the options below</h6>
				<ul>{wordCollection}</ul>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { rightSectionProps, isFeedback } = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		isFeedback,
	};
};

export default connect(mapStateToProps)(ClozeOptions);
